module.exports = __webpack_public_path__ + "static/img/img-gx.f9a3c27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/mob/img-gx.png
// module id = 8EXG
// module chunks = 0